import { CloudArrowUpIcon } from '@heroicons/react/24/solid'
import { useHistory } from '../../providers/HistoryProvider'
import { Modal } from '../common/Modal'
import { UploadRecordingSelectNotePage } from '../recording/modalpages/UploadRecordingSelectNotePage'
import { useEffect, useMemo, useState } from 'react'
import { TemplateObject } from '../../utils/TemplateObject'
import { UploadRecordingMainPage } from '../recording/modalpages/UploadRecordingMainPage'
import { RecordingUploadMode } from '../../utils/UploadUtils'
import { v4 as uuidv4 } from 'uuid'

enum UploadRecordingPage {
    INITIAL_SELECTION = "INITIAL_SELECTION",
    UPLOAD_RECORDING = "UPLOAD_RECORDING",
}

export default function UploadRecordingModal() {
    const {
        uploadRecordingModal, 
        setUploadRecordingModal,
        allNotesMetadata,
        multiDocEligible,
    } = useHistory()

    const [step, setStep] = useState<UploadRecordingPage>(UploadRecordingPage.UPLOAD_RECORDING)
    const [selectedNoteId, setSelectedNoteId] = useState<string>(uuidv4())
    const [template, setTemplate] = useState<TemplateObject>();    
    const [mode, setMode] = useState(RecordingUploadMode.ADD_TO_EXISTING_NOTE);
    const [fixedMode, setFixedMode] = useState(false);
    
    useEffect(() => {
        if (uploadRecordingModal) {
            if (allNotesMetadata && allNotesMetadata.length > 0) {
                setSelectedNoteId(allNotesMetadata[0].id);
            } else {
                setMode(RecordingUploadMode.CREATE_NEW_NOTE);
                setFixedMode(true);
            }
        }
    }, [allNotesMetadata, uploadRecordingModal]);

    useEffect(() => {
        if (multiDocEligible) {
            setStep(UploadRecordingPage.INITIAL_SELECTION);
        } else {
            setStep(UploadRecordingPage.UPLOAD_RECORDING);
        }
    }, [multiDocEligible])

    function onClose() {
        setUploadRecordingModal(false)
        setFixedMode(false);
        setStep(UploadRecordingPage.INITIAL_SELECTION)
        setMode(RecordingUploadMode.ADD_TO_EXISTING_NOTE)
        if (allNotesMetadata && allNotesMetadata.length > 0) {
            setSelectedNoteId(allNotesMetadata[0].id);
        }
    }

    const subTitle = useMemo(() => {
        if (step === UploadRecordingPage.INITIAL_SELECTION) {
            return fixedMode ? undefined : "What would you like to do with the audio?";
        } else {
            return "Upload an existing audio recording to generate notes.";
        }
    }, [step, fixedMode]);

    return (
        <Modal
            isOpen={uploadRecordingModal}
            onClose={onClose}
            title='Upload a recording'
            subTitle={subTitle}
            icon={<CloudArrowUpIcon className="h-6 w-6 text-blue-600" aria-hidden="true" />}
        >
            {step === UploadRecordingPage.INITIAL_SELECTION && <UploadRecordingSelectNotePage 
                selectedNoteId={selectedNoteId} 
                setSelectedNoteId={setSelectedNoteId}
                template={template}
                setTemplate={setTemplate}
                onProceed={() => setStep(UploadRecordingPage.UPLOAD_RECORDING)}
                mode={mode}
                fixedMode={fixedMode}
                setMode={setMode}
            />}
            {step === UploadRecordingPage.UPLOAD_RECORDING && <UploadRecordingMainPage 
                onBack={() => setStep(UploadRecordingPage.INITIAL_SELECTION)}
                upstreamNoteId={mode === RecordingUploadMode.ADD_TO_EXISTING_NOTE ? selectedNoteId : undefined}
                template={template}
                onClose={onClose}
                mode={mode}
            />}
        </Modal>
    )
}